<div class="d-flex">
  @if (video_url) {
    <iframe id="videoFrame" #videoFrame [appStoryblok]="_editable" [attr.width]="(max_width && max_width != '0') ? max_width + 'px' : (!max_height ? '100%' : 'auto')"  [attr.height]="(min_height && min_height != '0') ? min_height + 'px' : '100%'" style="min-width: 100%;" [src]="video_url | safe" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  }
</div>
